import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import generateExcel from "../../utils/excelFunctions";


export const buildSkippedEntriesExcelRows = (
  skippedEntries = [],
  columnOrder = null
) => {
  const list = Array.isArray(skippedEntries) ? skippedEntries : [];

  if (Array.isArray(columnOrder) && columnOrder.length > 0) {
    return list
      .map((item) => {
        const entry = item?.entry;
        if (!entry) return null;
        return columnOrder.reduce((row, key) => {
          row[key] = entry[key] ?? "";
          return row;
        }, {});
      })
      .filter(Boolean);
  }

  return list
    .map((item, index) => {
      const entry = item?.entry;
      if (!entry) return null;
      const row = {
        ...entry,
        // "S No.": index + 1,
      };
      // if (item?.row != null && item?.row !== "") {
      //   row["Source Row"] = item.row;
      // }
      // if (item?.reason) {
      //   row["Skip Reason"] = item.reason;
      // }
      return row;
    })
    .filter(Boolean);
};

const entryLabel = (count) => (Number(count) === 1 ? "entry" : "entries");

const SKIPPED_TEMPLATE_NOTE =
  "Invalid records were skipped during upload. Please check the skipped entries template.";

/** Short summary for bulk upload partial success (no row-level detail). */
export const getBulkUploadSkippedDialogMessage = (inserted = 0, skipped = 0) => {
  const successCount = Number(inserted) || 0;
  const skippedCount = Number(skipped) || 0;
  const parts = [];

  if (successCount > 0) {
    parts.push(
      `${successCount} ${entryLabel(successCount)} uploaded successfully.`
    );
  }

  if (skippedCount > 0) {
    parts.push(`${skippedCount} ${entryLabel(skippedCount)} skipped.`);
  }

  if (parts.length === 0) {
    return SKIPPED_TEMPLATE_NOTE;
  }

  return `${parts.join(" ")} ${SKIPPED_TEMPLATE_NOTE}`;
};

const BulkUploadSkippedDialog = ({
  open,
  onClose,
  skippedEntries = [],
  inserted = 0,
  skipped = 0,
  downloadFileName = "bulk_upload_skipped",
  downloadExcelColumns = null,
  downloadHandler,
  onDownload,
}) => {
  const entries = Array.isArray(skippedEntries) ? skippedEntries : [];
  const successCount = Number(inserted) || 0;
  const skippedCount = Number(skipped) || entries.length;
  const countSummary = [];
  if (successCount > 0) {
    countSummary.push(
      `${successCount} ${entryLabel(successCount)} uploaded successfully.`
    );
  }
  if (skippedCount > 0) {
    countSummary.push(`${skippedCount} ${entryLabel(skippedCount)} skipped.`);
  }

  const handleDownload = async () => {
    const rows = buildSkippedEntriesExcelRows(entries, downloadExcelColumns);
    if (!rows.length) return;
    if (typeof downloadHandler === "function") {
      await downloadHandler(rows);
    } else {
      generateExcel(rows, downloadFileName);
    }
    onDownload?.(rows);
    onClose?.();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: "bold" }}>Upload Summary</DialogTitle>
      <DialogContent>
        {countSummary.length > 0 && (
          <Typography
            variant="body1"
            sx={{ color: "#374151", lineHeight: 1.6, mb: 1.5, fontWeight: 500 }}
          >
            {countSummary.join(" ")}
          </Typography>
        )}
        <Typography variant="body1" sx={{ color: "#374151", lineHeight: 1.6 }}>
          {SKIPPED_TEMPLATE_NOTE}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button onClick={onClose} variant="outlined" sx={{ textTransform: "none" }}>
          Close
        </Button>
        <Button
          onClick={handleDownload}
          variant="contained"
          sx={{ backgroundColor: "#1C486B", textTransform: "none" }}
          disabled={entries.length === 0}
        >
          Download Skipped Entries
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BulkUploadSkippedDialog;
